import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppServiceService } from 'src/app/api/app-service.service';

@Component({
  selector: 'app-custom-confirm-dialog',
  templateUrl: './custom-confirm-dialog.component.html',
  styleUrls: ['./custom-confirm-dialog.component.scss'],
})
export class CustomConfirmDialogComponent implements OnInit {

  @Input() content: TemplateRef<any>;
  @Input() title: string = '';
  @Input() messageBody: string = '';
  @Input() cancelText: string = '';
  @Input() confirmText: string = '';

  @Input() onAction: Function;

  constructor(private modalCtrl: ModalController, public appService: AppServiceService) { }

  ngOnInit() { }



  cancel() {
    this.onAction({role:'cancel'});
  }

  confirm() {
    this.onAction({role:'confirm'});
  }


}
